/**
 * Typed Nutians API client (ISSUE-001 / ISSUE-100).
 *
 * `schema.ts` is generated from the committed OpenAPI document
 * (`docs/api/openapi.json`) by `pnpm --filter @nutians/api-client generate`.
 * Do not edit it by hand. This module wraps it in a thin, cookie-aware
 * `openapi-fetch` client shared by web (and later mobile/B2B).
 */
import createClient, {} from 'openapi-fetch';
/**
 * Create a typed client. `credentials: 'include'` ensures the Better-Auth
 * session cookie rides along on every request (web default).
 *
 * Mobile passes `credentials: 'omit'` and `getToken` for bearer-token mode.
 * Web calls `createApiClient({ baseUrl })` exactly as before — unchanged behaviour.
 */
export function createApiClient(options) {
    const client = createClient({
        baseUrl: options.baseUrl,
        credentials: options.credentials ?? 'include',
        fetch: options.fetch,
    });
    if (options.getToken) {
        const getToken = options.getToken;
        const bearerMiddleware = {
            async onRequest({ request }) {
                const token = await getToken();
                if (token) {
                    request.headers.set('Authorization', `Bearer ${token}`);
                }
                return request;
            },
            async onResponse({ response }) {
                if (response.status === 401 && options.onAuthError) {
                    await options.onAuthError();
                }
                // Return undefined — openapi-fetch v0.17 requires new Response() if modifying,
                // returning the original object fails instanceof check on Hermes.
            },
        };
        client.use(bearerMiddleware);
    }
    return client;
}
//# sourceMappingURL=index.js.map